"use client";

import { FC } from "react";
import { IFundMorningstarProps } from "./types";
import useMorningstarSecurities from "@portal/hooks/useMorningstarSecurities";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import FundMorningstarHoldings from "./holdings";
import FundMorningstarRegions from "./regions";
import { TextResources } from "@portal/assets/text/TextResources";
import SectorExposure from "./sectorExposure";
import RegularTabButton from "@portal/components/atoms/tabButton/regular";

const FundMorningstar: FC<IFundMorningstarProps> = ({ isin }) => {
  const { data: morningstarSecurities, isLoading } = useMorningstarSecurities(isin);

  if (isLoading) {
    return <PageSpinner />;
  }

  return (
    <TabGroup defaultIndex={0}>
      <div className="flex justify-center my-4">
        <TabList className="flex flex-wrap mb-1 gap-4 justify-center">
          <Tab>
            {({ selected }) => <RegularTabButton selected={selected} label={TextResources.FUND_DISTRIBUTION_HOLDINGS_TITLE} />}
          </Tab>
          <Tab>
            {({ selected }) => <RegularTabButton selected={selected} label={TextResources.FUND_DISTRIBUTION_REGIONS_TITLE} />}
          </Tab>
          <Tab>
            {({ selected }) => (
              <RegularTabButton selected={selected} label={TextResources.FUND_DISTRIBUTION_SECTOR_EXPOSURE_TITLE} />
            )}
          </Tab>
        </TabList>
      </div>
      <TabPanels>
        <TabPanel>
          <FundMorningstarHoldings morningstarSecurities={morningstarSecurities} />
        </TabPanel>
        <TabPanel>
          <FundMorningstarRegions morningstarSecurities={morningstarSecurities} />
        </TabPanel>
        <TabPanel>
          <SectorExposure morningstarSecurities={morningstarSecurities} />
        </TabPanel>
      </TabPanels>
    </TabGroup>
  );
};

export default FundMorningstar;
